import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutInfo, testimonials } from '@/mocks/articles';

const faqs = [
  {
    q: '51大赛吃瓜黑料网的爆料信息来源是否可靠？',
    a: '我们拥有专业的编辑团队和广泛的爆料人网络，所有信息发布前均经过多轮交叉验证。我们坚持事实核查原则，拒绝传播未经证实的虚假信息。对于无法完全核实的信息，我们会明确标注"待核实"标签。',
  },
  {
    q: '如何向51大赛投稿爆料？',
    a: '你可以通过发送邮件至 hello@ahljjx.cn 进行投稿。请尽可能提供详细信息及证据材料（如聊天截图、视频、音频等）。我们承诺严格保护爆料人的身份信息，绝不泄露。',
  },
  {
    q: '网站上的内容多久更新一次？',
    a: '我们的编辑团队7x24小时不间断追踪全网热点，确保每一个大瓜在第一时间送达。首页内容实时更新，热门事件会有专门的追踪报道系列，确保你不错过任何精彩后续。',
  },
  {
    q: '如果我发现网站上有不实信息怎么办？',
    a: '我们非常重视内容的真实性。如果你发现任何不实信息或需要更正的内容，请立即通过 hello@ahljjx.cn 联系我们。我们会在收到反馈后24小时内进行核查，一旦确认将立即更正或撤稿，并发布更正声明。',
  },
  {
    q: '51大赛吃瓜黑料网有移动端APP吗？',
    a: '目前我们专注于提供优质的网页端体验，移动端APP正在开发中。你可以通过手机浏览器访问我们的网站，我们已针对移动端进行了全面优化，确保在手机上也能获得流畅的吃瓜体验。',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.a,
    },
  })),
};

export default function AboutPage() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51大赛吃瓜黑料网',
    url: 'http://ahljjx.cn/',
    description: '深度吃瓜爱好者聚集地，聚焦网红明星塌房现场、博主反差猛料及私密聊天记录流出。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      email: aboutInfo.contact.email,
      contactType: 'customer support',
    },
  };

  return (
    <>
      <Navbar />
      <main>
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
        />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-3xl bg-primary-100 flex items-center justify-center mb-6 md:mb-8">
                <i className="ri-fire-line text-primary-500 text-3xl md:text-4xl"></i>
              </div>
              <p className="text-xs md:text-sm font-medium text-foreground-400 uppercase tracking-wider mb-3">
                始于 {aboutInfo.founded}
              </p>
              <h1 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mb-5 md:mb-7 leading-tight">
                关于 {aboutInfo.brandName}
              </h1>
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-2xl">
                {aboutInfo.intro}
              </p>
              <p className="text-foreground-500 text-sm italic mt-4">
                " {aboutInfo.mission} "
              </p>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="mb-10 md:mb-14">
              <p className="text-xs md:text-sm font-medium text-foreground-400 uppercase tracking-wider mb-3">
                数据说话
              </p>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
                平台实力
                <br />
                用数字证明
              </h2>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {aboutInfo.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 rounded-2xl p-6 md:p-8 text-center"
                >
                  <p className="font-heading text-3xl md:text-5xl font-black text-primary-500 mb-2">
                    {stat.value}
                  </p>
                  <p className="text-foreground-500 text-sm font-medium">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="mb-10 md:mb-14">
              <p className="text-xs md:text-sm font-medium text-foreground-400 uppercase tracking-wider mb-3">
                核心价值观
              </p>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
                我们坚守的
                <br />
                吃瓜精神
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {aboutInfo.values.map((value, idx) => (
                <div
                  key={idx}
                  className="bg-background-100 rounded-2xl p-6 md:p-7 transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                    <i className={`text-xl ${
                      ['ri-shield-check-line', 'ri-flashlight-line', 'ri-search-eye-line', 'ri-heart-line'][idx]
                    }`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2 whitespace-nowrap">
                    {value}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    {[
                      '坚持事实核查，拒绝传播未经证实的虚假信息，为每一位吃瓜群众负责。',
                      '7x24小时不间断追踪，确保每一个大瓜都能在第一时间送达你的眼前。',
                      '不止于表面，深入挖掘事件背后的真相，提供最全面的吃瓜体验。',
                      '用户的信任是我们最宝贵的资产，始终把吃瓜群众的体验放在第一位。',
                    ][idx]}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="mb-10 md:mb-14">
              <p className="text-xs md:text-sm font-medium text-foreground-400 uppercase tracking-wider mb-3">
                用户口碑
              </p>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
                吃瓜群众
                <br />
                怎么说
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-background-50 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-5 md:gap-6">
                  <div className="w-16 h-16 md:w-20 md:h-20 flex-shrink-0 rounded-xl overflow-hidden">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-accent-500 text-xs"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-3 font-heading italic">
                      &ldquo;{t.content}&rdquo;
                    </p>
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-bold text-foreground-950">{t.name}</span>
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-verified-badge-fill text-primary-500 text-sm"></i>
                      </div>
                      <span className="text-xs text-foreground-400">{t.role}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-10 md:mb-14">
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mb-4 leading-tight">
                联系我们
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-lg leading-relaxed">
                有独家爆料线索？欢迎联系我们。你的信息将被严格保密。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-3xl mx-auto">
              <div className="bg-background-100 rounded-2xl p-6 text-center transition-all duration-300 hover:-translate-y-1">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1.5">爆料邮箱</h3>
                <p className="text-foreground-500 text-xs">{aboutInfo.contact.email}</p>
              </div>
              <div className="bg-background-100 rounded-2xl p-6 text-center transition-all duration-300 hover:-translate-y-1">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1.5">官方微信</h3>
                <p className="text-foreground-500 text-xs">{aboutInfo.contact.wechat}</p>
              </div>
              <div className="bg-background-100 rounded-2xl p-6 text-center transition-all duration-300 hover:-translate-y-1">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-3">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1.5">办公地址</h3>
                <p className="text-foreground-500 text-xs">{aboutInfo.contact.address}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="mb-10 md:mb-14">
              <p className="text-xs md:text-sm font-medium text-foreground-400 uppercase tracking-wider mb-3">
                常见问题
              </p>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
                吃瓜群众
                <br />
                常问的问题
              </h2>
            </div>

            <div className="max-w-3xl mx-auto space-y-3">
              {faqs.map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-2xl overflow-hidden">
                  <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                    <span className="font-heading text-base md:text-lg font-bold text-foreground-950 pr-4">
                      {faq.q}
                    </span>
                    <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 group-open:bg-primary-50 group-open:text-primary-500 transition-colors">
                      <i className="ri-add-line group-open:ri-subtract-line text-sm"></i>
                    </div>
                  </summary>
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-foreground-950">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col items-center text-center">
              <h2 className="font-heading text-2xl md:text-4xl font-black text-white mb-3 leading-tight">
                手握大瓜
                <span className="text-foreground-400 font-normal"> ？</span>
              </h2>
              <p className="text-foreground-300 text-sm md:text-base max-w-md mb-7 md:mb-8 leading-relaxed">
                有独家猛料？欢迎给我们投稿。你的信息将被严格保密，爆料人身份绝不泄露。
              </p>
              <a
                href={`mailto:${aboutInfo.contact.email}`}
                className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即爆料
                <div className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
                  <i className="ri-send-plane-line"></i>
                </div>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}